module.exports = __webpack_public_path__ + "static/media/mia-malkova-lesb.ffde36b3.jpg";